import * as React from "react"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

// Wave 2 — Badge variants aligned to design tokens.
// Semantic (new): success | warning | danger | info (+ outline kept)
// Legacy (kept): default | secondary | destructive (alias of danger) | outline
const badgeVariants = cva(
  "inline-flex items-center rounded-md border px-2 py-0.5 text-micro font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-border-focus focus:ring-offset-0",
  {
    variants: {
      variant: {
        // Semantic (Wave 2) — tinted background + matching foreground, subtle border
        success: "border-transparent bg-status-success/10 text-status-success",
        warning: "border-transparent bg-status-warning/10 text-status-warning",
        danger:  "border-transparent bg-status-error/10 text-status-error",
        info:    "border-transparent bg-status-info/10 text-status-info",
        outline: "border-subtle text-foreground-secondary bg-transparent",
        // Legacy
        default:     "border-transparent bg-primary text-primary-foreground hover:bg-primary/80",
        secondary:   "border-transparent bg-surface-card-hover text-foreground hover:bg-surface-overlay",
        destructive: "border-transparent bg-status-error/10 text-status-error",  // alias of danger
      },
    },
    defaultVariants: { variant: "default" },
  }
)

function Badge({ className, variant, ...props }) {
  return <div className={cn(badgeVariants({ variant }), className)} {...props} />
}

export { Badge, badgeVariants }
